import script from "./AdminProductsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductsPage.vue?vue&type=style&index=0&id=36fe8668&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fe8668"]])

export default __exports__